define('behavior/download.file.on.event.behavior',['require','exports','module','marionette','bluebird'],function(require, exports, module) {
  //prettier-ignore
  var Mn = require('marionette'),
      Promise = require('bluebird');

  var DownloadFileOnEventBehavior = Mn.Behavior.extend({
    defaults: {
      eventName: 'press',
      eventSource: null,
      fileDownloadUrl: null,
    },

    onFirstRender: function() {
      var eventSource = this.getOption('eventSource') || this.view;
      this.listenTo(eventSource, this.getOption('eventName'), this.onEvent);
    },

    onEvent: function() {
      var newWindow = window.open('', '_blank');
      var model = this.getOption('model') || this.view.model;
      Promise.resolve(Mn._getValue(this.getOption('fileDownloadUrl'), this, [model])).then(function(url) {
        if (url) {
          newWindow.location = url;
        } else {
          newWindow.close();
        }
      });
    },
  });

  module.exports = DownloadFileOnEventBehavior;
});

